import { tokens } from '@arvoreeducacao/bonsai-ds'
import type { Settings } from 'react-slick'

export const carouselCollectionShelfSettings: Settings = {
  lazyLoad: 'ondemand',
  variableWidth: true,
  slidesToScroll: 6,
  slidesToShow: 6,
  dots: false,
  infinite: false,
  speed: 500,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: tokens.breakpoints.desktopXlarge,
      settings: {
        slidesToScroll: 5,
        slidesToShow: 5
      }
    },
    {
      breakpoint: tokens.breakpoints.desktopLarge,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4
      }
    },
    {
      breakpoint: tokens.breakpoints.desktop,
      settings: {
        slidesToScroll: 3,
        slidesToShow: 3
      }
    },
    {
      breakpoint: tokens.sizes.smScreen,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1
      }
    }
  ]
}
